module.exports = __webpack_public_path__ + "img/kefu.9a75ad45.png";